import { Platform } from 'ionic-angular';
import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController } from 'ionic-angular';
import { MiddlewareService } from '../../../services/middleware.service';
import { Storage } from '@ionic/storage';
import { ChecklistPage } from '../../checklist/checklist';
import * as Fuse from 'fuse.js';
import { eGENA_Checkliste } from '../../../visionet/Checkliste'
import { SingletonKlickhandlerService } from '../../../services/klickhandler.service';
import { TEILNEHMERKENNUNG_GENERISCH } from '../../../visionet/TeilnehmerInfo';
import { version } from '../../../../package.json';
import { config } from '../../../../package.json';
import { GlobalsSingleton } from '../../../app/core/GlobalsSingleton';
import { Wischnavigation } from '../../../Wischnavigation';


//@IonicPage()
@Component({
	selector: 'page-phone-search-select-list',
	templateUrl: 'SearchPhoneSelectListPage.html'
})
export class SearchPhoneSelectListPage {

	fuseOptions = {
		shouldSort: true,
		threshold: 0.15,
		location: 0,
		distance: 200,
		maxPatternLength: 32,
		minMatchCharLength: 3,
		keys: [
			"titel",
			"schlüsselwörterFürAlphabetischeSuche"
		]
	};

	curSearchTerm: string
	fuseSearch: any
	isLoaded: boolean = false;

	activeSearch: string = ''



	ausgewaehlterPatiententyp: string = "" // Kind, Erwachsender oder Schwangere
	patiententypTagToName = {"k": "Kind","e": "Erwachsener", "s":"Schwangere"};

	curSearchResultChecklists: eGENA_Checkliste[]

	//indices
	azIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	abcdeIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	bodynavIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	reanIndex: eGENA_Checkliste[] = []
	fuzzySearchIndex: eGENA_Checkliste[] = []
	checklistIndex: any[] = []





	constructor(public globals: GlobalsSingleton, public platform: Platform, public navCtrl: NavController, public navParams: NavParams, private checklistService: MiddlewareService, public storage: Storage, public popoverCtrl: PopoverController, public klickhandlerSingleton : SingletonKlickhandlerService) {
		console.info("SearchPhoneSelectListPage()");
		this.ausgewaehlterPatiententyp = navParams.get('ausgewaehlterPatiententyp');
		this.activeSearch = navParams.get('activeSearch');
		this.curSearchResultChecklists = globals.getCurSearchResultChecklists();

		this.abcdeIndex = globals.getAbcdeIndex();
		this.azIndex = globals.getAzIndex();
		this.bodynavIndex = globals.getBodynavIndex();
		this.fuzzySearchIndex = globals.getFuzzySearchIndex();
	}

	ionViewWillEnter() {
		if (this.globals.isIOS())
			Wischnavigation.iosPreventSafariDefaultnav();
	}




	getFuzzySearch() {
		let fuseSearch = new Fuse(this.fuzzySearchIndex, this.fuseOptions)
		this.activeSearch = 'search'
		this.ausgewaehlterPatiententyp = ""
		let searchResult = fuseSearch.search(this.curSearchTerm, );
		this.curSearchResultChecklists = searchResult
	}




	/**	=== Visionet(sl) ==========
	 *	Zurück zur Startseite
	 */
	goHome(event : UIEvent) : void {
		this.navCtrl.goToRoot( {
			animate : true,
			animation: "ios-transition"
			}
		);
	}







	@ViewChild('search') search : any | undefined;
	
	ionViewDidEnter() : void {
		if (this.search != undefined) {
		    setTimeout(() => {
		      this.search.setFocus();
		    }, 1500);
		}
	  }





}



// WEBPACK FOOTER //
// ./src/pages/search/Phone/SearchPhoneSelectListPage.ts